// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router/index'
import App from './App'
import $ from 'jquery'
import {axiosInstance, axiosSSO, axiosWeb, axiosOpenApi} from './assets/js/axios'
import {Utils} from './assets/js/util'
import {UserUtils} from './assets/js/user'
import store from './store/index'
import {CyLoading, CyMsgBox} from './assets/js/tiptool'
import {Constants} from './assets/js/constants'

import 'font-awesome/css/font-awesome.css'
import './assets/css/app.css'

window.$ = $
window.jQuery = $

Vue.prototype.$Utils = Utils
Vue.prototype.$UserUtils = UserUtils
Vue.prototype.$Loading = CyLoading
Vue.prototype.$Msgbox = CyMsgBox
Vue.prototype.$axios = axiosInstance
Vue.prototype.$axiosSSO = axiosSSO
Vue.prototype.$axiosWeb = axiosWeb
Vue.prototype.$axiosOpenApi = axiosOpenApi
Vue.prototype.$Constants = Constants

Vue.prototype.$fileDownloadUrl = process.env.File_Download_Url

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js